import { render, staticRenderFns } from "./FormListEnglish.vue?vue&type=template&id=1246634e&scoped=true"
import script from "./FormListEnglish.vue?vue&type=script&lang=js"
export * from "./FormListEnglish.vue?vue&type=script&lang=js"
import style0 from "./FormListEnglish.vue?vue&type=style&index=0&id=1246634e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1246634e",
  null
  
)

export default component.exports